import { useMemo } from "react";
import { BuildingsIcon } from "@phosphor-icons/react";
import { bucketUrlPrefix } from "common/config";
import { findImageByName } from "common/utils/general";
import { useFilters } from "common/hooks";
import { cn } from "@/lib/utils";

// Categories with no icon of their own — alias to a close DB-driven one instead.
const ICON_NAME_ALIASES: Record<string, string> = {
  tourist_attraction: "museum",
  art_gallery: "museum",
};

/**
 * Icon for a business type, served by the filters API so new types get one
 * without a release. Falls back to a pin for types we don't cover.
 */
export const BusinessTypeIcon = ({
  businessType,
  className,
}: {
  businessType: string;
  className?: string;
}) => {
  const { businessTypesFrontend } = useFilters();

  const iconPath = useMemo(() => {
    const key = (businessType || "").trim().toLowerCase().replace(/\s+/g, "_");
    const lookupName = ICON_NAME_ALIASES[key] ?? businessType;
    const image = findImageByName(lookupName, businessTypesFrontend);
    return image ? bucketUrlPrefix + image : null;
  }, [businessType, businessTypesFrontend]);

  if (iconPath) {
    return (
      <img
        src={iconPath}
        alt={businessType}
        // Flattened to a single tone so it matches the text beside it.
        className={cn(
          "w-4 h-4 object-contain filter brightness-0 dark:brightness-[10]",
          className,
        )}
      />
    );
  }

  return (
    <BuildingsIcon
      size={16}
      weight="fill"
      className={cn("w-4 h-4", className)}
    />
  );
};

export default BusinessTypeIcon;
